import React from "react";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";
import AOS from "aos";

import Pro22 from "@/public/static/images/project_22.jpg";
import Pro23 from "@/public/static/images/project_23.png";
import Pro24 from "@/public/static/images/project_24.png";
import Pro25 from "@/public/static/images/project_25.png";
import Pro26 from "@/public/static/images/project_26.png";
import Pro27 from "@/public/static/images/project_27.png";
import Pro28 from "@/public/static/images/project_28.png";

function printing() {
  AOS.init({
    offset: 200,
    duration: 600,
    easing: "ease-in-out-sine",
    delay: 200,
    mirror: true,
  });
  return (
    <div className="wrapper">
      <Header />
      <section className="proj">
        <div className="container">
          <div className="row">
            <div className="col-12 project_box">
              <div className="row">
                <div className="col-12 col-md-7 order-md-1 order-2">
                  <div>
                    <div className="project-heading">
                      <h1 className="t-yellow">Printing</h1>
                    </div>
                  </div>
                  {/* <div className="badge_box">
                    <Link href="/ourservice/printing_logistics">
                      <span className="badge rounded-pill text-bg-light">
                        Media Printing
                      </span>
                    </Link>
                    <Link href="/ourservice/printing_logistics">
                      <span className="badge rounded-pill text-bg-light">
                        Material Printing
                      </span>
                    </Link>
                  </div> */}
                  <div className="project_content-inner project-list">
                    <p>
                      With Link rich history dating back to 1916, ITP Inc., our{" "}
                      <br />
                      esteemed parent company, initially started as Link
                      printing <br />
                      company in Japan. Throughout the years, we have <br />
                      primarily focused on catering to the printing needs of{" "}
                      <br />
                      renowned local department stores.
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-5 order-md-2 order-1">
                  <Image
                    loading="lazy"
                    src={Pro22}
                    alt="Printing"
                    className="img-fluid mx-auto "
                  />
                </div>
              </div>
            </div>

            <div className="col-12 project_content">
              <div className="row mb-5">
                <div className="col-12 mb-5 project_content-inner">
                  <h2 className="t-yellow mb-2">High Quality Printing</h2>
                  <p className="mb-1">Procurement from around the world</p>
                </div>
                <div className="col-12 mb-5 project_content-inner">
                  <div className="row row-cols-1 row-cols-md-2 g-4 mb-5">
                    <div className="col">
                      <div className="d-flex align-items-center">
                        <div className="flex-shrink-0">
                          <Image
                            loading="lazy"
                            src={Pro25}
                            alt="Printing"
                            className="img-fluid mb-3"
                          />
                        </div>
                        <div className="flex-grow-1 ms-5">
                          <p>
                            <span className="fw-bold">
                              Offset Printing - Paper
                            </span>
                            <br />
                            Manuals, Catalogs, Leaflet, Guidebook
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="d-flex align-items-center">
                        <div className="flex-shrink-0">
                          <Image
                            loading="lazy"
                            src={Pro26}
                            alt="Printing"
                            className="img-fluid mb-3"
                          />
                        </div>
                        <div className="flex-grow-1 ms-5">
                          <p>
                            <span className="fw-bold">Packaging</span>
                            <br />
                            Package box, Carton box, Plastic bag, Paper box etc.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="d-flex align-items-center">
                        <div className="flex-shrink-0">
                          <Image
                            loading="lazy"
                            src={Pro27}
                            alt="Printing"
                            className="img-fluid mb-3"
                          />
                        </div>
                        <div className="flex-grow-1 ms-5">
                          <p>
                            <span className="fw-bold">Sticker & Label</span>
                            <br />
                            Offset Printing, Silk screen printing For Paper,
                            Plastic, Aluminum, Metal etc.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="d-flex align-items-center">
                        <div className="flex-shrink-0">
                          <Image
                            loading="lazy"
                            src={Pro28}
                            alt="Printing"
                            className="img-fluid mb-3"
                          />
                        </div>
                        <div className="flex-grow-1 ms-5">
                          <p>
                            <span className="fw-bold">
                              Milk-Run (JIT) delivery
                            </span>
                            <br />
                            Support “Just in time” delivery from our warehouse.
                            15 years experience of JIT.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-5 project_content-inner">
                  <h2 className="t-yellow mb-2">What we can do</h2>
                  <Image
                    loading="lazy"
                    src={Pro24}
                    alt="Printing"
                    className="img-fluid mb-3"
                  />
                </div>

                <div className="col-12 mb-5 project_content-inner">
                  <h2 className="t-yellow mb-2">Our process</h2>
                  <Image
                    loading="lazy"
                    src={Pro23}
                    alt="Printing"
                    className="img-fluid mb-3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default printing;
